/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePointDriveResult } from '../../models/charge-point-drive-result';

export interface ChangeAvailabilityChargePoint$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;

/**
 * The uid of the selected connector or 0 for requesting general chargepoint
 */
  connectorUid: string;

/**
 * The list of AvailabilityType OCPP :
 */
  availabilityType: 'OPERATIVE' | 'INOPERATIVE';
}

export function changeAvailabilityChargePoint(http: HttpClient, rootUrl: string, params: ChangeAvailabilityChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePointDriveResult>> {
  const rb = new RequestBuilder(rootUrl, changeAvailabilityChargePoint.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
    rb.path('connectorUid', params.connectorUid, {});
    rb.query('availabilityType', params.availabilityType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePointDriveResult>;
    })
  );
}

changeAvailabilityChargePoint.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/changeavailability/{connectorUid}';
